// Auth0 logout address: ends the Auth0 session, then sends the browser to
// returnTo, which must be listed in the application's Allowed Logout URLs.
export function buildLogoutUrl(baseUrl, clientId, returnTo) {
  return (
    baseUrl.replace(/\/+$/, "") +
    "/v2/logout?client_id=" +
    encodeURIComponent(clientId) +
    "&returnTo=" +
    encodeURIComponent(returnTo)
  );
}
